@if (invitationOfferOverviewResource.isLoading()) {
  <app-loading />
} @else if (invitationOfferOverviewResource.value()) {
  <app-step-8-2-3-rfq-preview-price-list
    [isCustomerType]="false"
    [isReadOnly]="isReadOnly()"
    [invitationOfferOverview]="invitationOfferOverviewResource.value()!"
    (submitServiceFees)="saveServiceFees($event)"
    (submitImplementationFees)="saveImplementationFees($event)"
    (submitIntegrationSetupFees)="saveIntegrationSetupFees($event)"
    (submitIntegrationOtherFees)="saveIntegrationOtherFees($event)"
  ></app-step-8-2-3-rfq-preview-price-list>
}
